<template>
  <IconLucideCalendarPlus />
</template>
